<template>
  <table class="table is-fullwidth is-striped" v-if="hasGamecamConfigs">
    <thead>
      <tr>
        <th>Email</th>
        <th>Shared</th>
        <th>Post in chat</th>
        <th>Created By</th>
      </tr>
    </thead>

    <tbody>
      <tr v-for="gamecamConfig in gamecamConfigs" :key="gamecamConfig.id">
        <td>
          <span>{{ gamecamConfig.email }}</span>
        </td>
        <td>
          <span>{{ gamecamConfig.shared ? 'YES' : 'NO' }}</span>
        </td>
        <td>
          <span>{{ gamecamConfig.postInChat ? 'YES' : 'NO' }}</span>
        </td>
        <td>
          <span v-if="gamecamConfig.createdBy">
            <span v-if="nameOfUserWithId(gamecamConfig.createdBy)">{{ nameOfUserWithId(gamecamConfig.createdBy) }} (<span>{{ gamecamConfig.createdBy }}_LLUser</span>)</span>
            <span v-else>{{ gamecamConfig.createdBy }}_LLUser</span>
          </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import {
  GET_USER_WITH_ID
} from "@/modules/users/usersCacheStore.js"

export default {
  name: "HuntAreaGamecamConfigsList",

  props: {
    huntArea: {
      type: Object,
      required: true
    },

    gamecamConfigs: {
      type: Array,
      required: true
    },

    usersCacheStorePath: {
      type: String,
      required: true
    }
  },

  methods: {
    nameOfUserWithId(userId) {
      if (!userId) {
        return null;
      }

      const getUserWithIdPath = `${this.usersCacheStorePath}/${GET_USER_WITH_ID}`;
      const user = this.$store.getters[getUserWithIdPath](userId);

      if (!user) {
        return null;
      }

      return `${user.firstName} ${user.lastName}`
    }
  },

  computed: {
    hasGamecamConfigs() {
      if (!this.gamecamConfigs) {
        return false;
      }

      return this.gamecamConfigs.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
.table td {
  border-bottom: 0;
}

td span {
  white-space: nowrap;
}
</style>
